var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveFundWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 6.25C4.52065 6.25 3.82118 6.53973 3.30546 7.05546C2.78973 7.57118 2.5 8.27065 2.5 9V18C2.5 18.7293 2.78973 19.4288 3.30546 19.9445C3.82118 20.4603 4.52065 20.75 5.25 20.75H19.25C19.9793 20.75 20.6788 20.4603 21.1945 19.9445C21.7103 19.4288 22 18.7293 22 18V9C22 8.27065 21.7103 7.57118 21.1945 7.05546C20.6788 6.53973 19.9793 6.25 19.25 6.25H5.25ZM16.75 12.25C16.4185 12.25 16.1005 12.3817 15.8661 12.6161C15.6317 12.8505 15.5 13.1685 15.5 13.5C15.5 13.8315 15.6317 14.1495 15.8661 14.3839C16.1005 14.6183 16.4185 14.75 16.75 14.75C17.0815 14.75 17.3995 14.6183 17.6339 14.3839C17.8683 14.1495 18 13.8315 18 13.5C18 13.1685 17.8683 12.8505 17.6339 12.6161C17.3995 12.3817 17.0815 12.25 16.75 12.25Z",
    fill: "#481AA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.735 3.06744C17.0311 2.98854 17.3413 2.97873 17.6418 3.03875C17.9423 3.09878 18.2249 3.22705 18.468 3.41365C18.711 3.60025 18.9079 3.84021 19.0435 4.11499C19.1791 4.38977 19.2498 4.69203 19.25 4.99844H9.25L16.735 3.06744Z",
    fill: "#481AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFundWallet);
export default __webpack_public_path__ + "static/media/active_fund_wallet.9698a185e59827bf07cc8a7002d25c8d.svg";
export { ForwardRef as ReactComponent };